import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import AppBar              from '@material-ui/core/AppBar'
import Dialog              from '@material-ui/core/Dialog'
import IconButton          from '@material-ui/core/IconButton'
import Slide               from '@material-ui/core/Slide'
import Toolbar             from '@material-ui/core/Toolbar'
import { TransitionProps } from '@material-ui/core/transitions/transition'
import Typography          from '@material-ui/core/Typography'
import CloseIcon           from '@material-ui/icons/Close'
import styled              from 'styled-components'
import { mainAppBarTool }  from '../../project-utils/common-styles'

const DialogTransition = (props: TransitionProps) => (
  <Slide direction={'up'} {...props} />
)

const AppBarIconButton = styled(IconButton)`
  ${mainAppBarTool}
`

interface FullScreenDialogProps {
  isOpen: boolean
  close: () => void
  title: React.ReactNode
  children: React.ReactNode
}

class FullScreenDialog extends React.Component<FullScreenDialogProps> {
  public componentDidUpdate (lastProps) {
    if (lastProps.isOpen === this.props.isOpen) return

    if (this.props.isOpen) {
      this.attachEscClose()
    } else {
      this.detachEscClose()
    }
  }

  public render () {
    const {
      isOpen,
      close,
      title,
      children,
    } = this.props

    const phrasing = {
      title:
        (
          <Typography variant={'title'} color={'inherit'}>
            <FormattedMessage id={`generic.${title}`} />
          </Typography>
        ),
    }

    return (
      (
        <Dialog
          keepMounted={false}
          fullScreen
          open={isOpen}
          TransitionComponent={DialogTransition}
        >
          <AppBar position={'static'}>
            <Toolbar>
              <AppBarIconButton onClick={close} color={'inherit'}>
                <CloseIcon />
              </AppBarIconButton>
              {phrasing.title}
            </Toolbar>
          </AppBar>
          {children}
        </Dialog>
      )
    )
  }

  public attachEscClose () {
    window.addEventListener('keydown', this.closeOnEscapeKey)
  }

  private detachEscClose () {
    window.removeEventListener('keydown', this.closeOnEscapeKey)
  }

  private closeOnEscapeKey = e => {
    /*
     27 is the escape key, there was no other way other
     than writing this comment to clarify this ;)
     */
    if (e.keyCode === 27) {
      this.props.close()
    }
  }
}

export default FullScreenDialog



// WEBPACK FOOTER //
// ./src/components/molecules/FullScreenDialog.tsx